import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_record_workrelated_accidents_and_diseases_and_repo'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_record_workrelated_accidents_and_diseases_and_repo',
  name: 'Does the facility record work-related accidents and diseases and report them to the competent authority in line with legal requirements?',
  description:
    'Consult applicable legal requirements.\r\r\n\r\r\nIf the facility has not recorded work-related accidents and diseases in line with legal requirements, OR the facility has not reported them to the competent authority in line with legal requirements, answer No.\r\r\n\r\r\nIf legal requirements ONLY require recording, and the facility has recorded work-related accidents and diseases in line with these requirements (but not reported them, because there is no legal requirement to do so), answer Yes.\r\r\n\r\r\nIf there are no applicable legal requirements that apply to recording or to reporting work-related accidents and diseases, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-52',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17020,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
